import { __decorate } from "tslib";
import { Component, Vue } from "vue-facing-decorator";
let GridLayout = class GridLayout extends Vue {};
GridLayout = __decorate([Component({})], GridLayout);
export default GridLayout;